import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FormControl, Grid, Skeleton, TextField } from "@mui/material";
import StatusGenerator from "../StatusGenerator/StatusGenerator";
import { useSelector } from "react-redux";
const getUsersState = (state) => state.usersReducer;

export default function ViewandEditForm({
  formType,
  handleStoryUpdate,
  formValues,
  formStates,
  showSkeleton,
  singleStoryData,
  handleCommentChange,
  inputValues,
  inputStates,
}) {
  const { authUser } = useSelector(getUsersState);
  return (
    <Box sx={{ width: "100%" }}>
      <React.Fragment>
        <Box p="0px 10px">
          <Grid container spacing={1}>
            {/* <Grid item xs={12}>
              <Box display={"flex"} alignItems={"center"}>
                <Typography sx={{ fontWeight: "500", pr: 1 }}>
                  Approval Status:
                </Typography>
                {Object.keys(singleStoryData)?.length !== 0 ? (
                  singleStoryData?.approvalStatus === 0 ? (
                    <StatusGenerator
                      statusText="Submitted"
                      variant="yellowFilled"
                    />
                  ) : singleStoryData?.approvalStatus === 1 ? (
                    <StatusGenerator
                      statusText="State Officer Approved"
                      variant="greenOutlined"
                    />
                  ) : singleStoryData?.approvalStatus === 2 ? (
                    <StatusGenerator
                      statusText="State Officer Disapproved"
                      variant="redOutlined"
                    />
                  ) : singleStoryData?.approvalStatus === 3 ? (
                    <StatusGenerator
                      statusText="State Co-ord. Approved"
                      variant="greenOutlined"
                    />
                  ) : singleStoryData?.approvalStatus === 4 ? (
                    <StatusGenerator
                      statusText="State Co-ord. Disapproved"
                      variant="redOutlined"
                    />
                  ) : singleStoryData?.approvalStatus === 5 ? (
                    <StatusGenerator
                      statusText="HQ Approved"
                      variant="greenFilled"
                    />
                  ) : singleStoryData?.approvalStatus === 6 ? (
                    <StatusGenerator
                      statusText="HQ Disapproved"
                      variant="redFilled"
                    />
                  ) : (
                    ""
                  )
                ) : (
                  <Skeleton variant="rounded" width={50} height={30} />
                )}
              </Box>
            </Grid> */}
            <Grid item xs={12}>
              <FormControl fullWidth variant="outlined">
                <label
                  style={{
                    marginBottom: "10px",
                    fontFamily: Typography.secondaryFont,
                  }}
                  htmlFor="successstory"
                >
                  <Typography sx={{ fontSize: "14px" }}>
                    Success Story
                  </Typography>
                </label>
                {showSkeleton ? (
                  <Skeleton
                    variant="rounded"
                    animation="wave"
                    height={150}
                    width={500}
                  />
                ) : (
                  <TextField
                    error={formStates.storyError}
                    helperText={formStates.storyErrorMsg}
                    multiline
                    rows={6}
                    name="story"
                    value={formValues.story}
                    size="small"
                    id="story"
                    variant="outlined"
                    InputProps={{
                      spellCheck: true,
                      lang: "English",
                      readOnly: formType === "view" ? true : false,
                    }}
                    onChange={handleStoryUpdate}
                  />
                )}
              </FormControl>
            </Grid>
            {((authUser?.role !== "SAED_LGI" &&
              singleStoryData?.approvalStatus >= 0) ||
              (authUser?.role === "SAED_LGI" &&
                singleStoryData?.approvalStatus > 0)) &&
              (showSkeleton ? (
                <Skeleton
                  variant="rounded"
                  animation="wave"
                  height={100}
                  width={500}
                />
              ) : (
                <>
                  <Grid item xs={12}>
                    <Typography fontWeight={"bold"}>Approvals</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl fullWidth variant="outlined">
                      <label
                        style={{
                          marginBottom: "10px",
                          fontFamily: Typography.secondaryFont,
                        }}
                        htmlFor="stateofficer"
                      >
                        <Typography sx={{ fontSize: "14px" }}>
                          State Officer's Comment
                        </Typography>
                      </label>

                      <TextField
                        error={inputStates.commentError1}
                        helperText={inputStates.commentErrorMsg1}
                        placeholder="Type your comment here"
                        multiline={true}
                        name="comment"
                        value={
                          singleStoryData?.commentByStateSaedOfficer !== "" &&
                          singleStoryData?.commentByStateSaedOfficer !== null
                            ? singleStoryData?.commentByStateSaedOfficer
                            : inputValues.comment
                        }
                        size="small"
                        id="commentByStateSaedOfficer"
                        variant="outlined"
                        InputProps={{
                          spellCheck: true,
                          lang: "English",
                          readOnly:
                            singleStoryData?.commentByStateSaedOfficer !== "" &&
                            singleStoryData?.commentByStateSaedOfficer !== null,
                        }}
                        onChange={(e) => handleCommentChange(e, 1)}
                      />
                    </FormControl>
                  </Grid>
                  {((authUser?.role !== "SAED_LGI" &&
                    singleStoryData?.approvalStatus >= 1 &&
                    singleStoryData?.approvalStatus !== 2) ||
                    (authUser?.role === "SAED_LGI" &&
                      singleStoryData?.approvalStatus >= 3)) && (
                    <Grid item xs={12}>
                      <FormControl fullWidth variant="outlined">
                        <label
                          style={{
                            marginBottom: "10px",
                            fontFamily: Typography.secondaryFont,
                          }}
                          htmlFor="commentByStateCordinatorOfficer"
                        >
                          <Typography sx={{ fontSize: "14px" }}>
                            State Co-ordinator's Comment
                          </Typography>
                        </label>

                        <TextField
                          error={inputStates.commentError2}
                          helperText={inputStates.commentErrorMsg2}
                          placeholder="Type your comment here"
                          multiline={true}
                          name="comment"
                          value={
                            singleStoryData?.commentByStateCordinatorOfficer !==
                              "" &&
                            singleStoryData?.commentByStateCordinatorOfficer !==
                              null
                              ? singleStoryData?.commentByStateCordinatorOfficer
                              : inputValues.comment
                          }
                          size="small"
                          id="commentByStateCordinatorOfficer"
                          variant="outlined"
                          InputProps={{
                            spellCheck: true,
                            lang: "English",
                            readOnly:
                              singleStoryData?.commentByStateCordinatorOfficer !==
                                "" &&
                              singleStoryData?.commentByStateCordinatorOfficer !==
                                null,
                          }}
                          onChange={(e) => handleCommentChange(e, 2)}
                        />
                      </FormControl>
                    </Grid>
                  )}
                  {((authUser?.role !== "SAED_LGI" &&
                    singleStoryData?.approvalStatus >= 3 &&
                    singleStoryData?.approvalStatus !== 4) ||
                    (authUser?.role === "SAED_LGI" &&
                      singleStoryData?.approvalStatus >= 5)) && (
                    <Grid item xs={12}>
                      <FormControl fullWidth variant="outlined">
                        <label
                          style={{
                            marginBottom: "10px",
                            fontFamily: Typography.secondaryFont,
                          }}
                          htmlFor="commentByHQOfficer"
                        >
                          <Typography sx={{ fontSize: "14px" }}>
                            HQ's Comment
                          </Typography>
                        </label>

                        <TextField
                          error={inputStates.commentError3}
                          helperText={inputStates.commentErrorMsg3}
                          placeholder="Type your comment here"
                          multiline={true}
                          name="comment"
                          value={
                            singleStoryData?.commentByHQOfficer !== "" &&
                            singleStoryData?.commentByHQOfficer !== null
                              ? singleStoryData?.commentByHQOfficer
                              : inputValues.comment
                          }
                          size="small"
                          id="commentByHQOfficer"
                          variant="outlined"
                          InputProps={{
                            spellCheck: true,
                            lang: "English",
                            readOnly:
                              singleStoryData?.commentByHQOfficer !== "" &&
                              singleStoryData?.commentByHQOfficer !== null,
                          }}
                          onChange={(e) => handleCommentChange(e, 3)}
                        />
                      </FormControl>
                    </Grid>
                  )}
                </>
              ))}
          </Grid>
        </Box>
      </React.Fragment>
    </Box>
  );
}
